// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"31d6cfe0","367":"1f48ee8d","661":"31d6cfe0"}[chunkId] + ".chunk.css";
};